import axios, { AxiosError } from 'axios'

export interface ApiErrorResponse {
    message: string
    errors?: Record<string, string[]>
}

export function isAxiosError(error: unknown): error is AxiosError<ApiErrorResponse> {
    return axios.isAxiosError(error)
}

export function getAxiosErrorMessage(error: unknown, fallback = 'Something went wrong'): string {
    if (isAxiosError(error)) {
        return error.response?.data?.message ?? error.message ?? fallback
    }
    return fallback
}
